import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-granth-seller-dispatch-report-list',
  templateUrl: './granth-seller-dispatch-report-list.component.html',
  styleUrl: './granth-seller-dispatch-report-list.component.scss'
})
export class GranthSellerDispatchReportListComponent implements OnInit {

  sellerData: any[] = [];
  updateStatus: boolean = false;
  isLoading: boolean = false;

  // ✅ TOTAL VARIABLE
  totalCopies: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GranthSellerDispatchReportListComponent>
  ) {
    console.log('Dialog Data:', data);
debugger
    this.sellerData = data?.sellerData || [];
    this.updateStatus = data?.updateStatus || false;
  }

  ngOnInit(): void {
    this.calculateTotals();
  }

  // =========================
  // TOTAL CALCULATION
  // =========================
  calculateTotals(): void {
    this.totalCopies = this.sellerData.reduce((sum, item) => {
      return sum + Number(item.book_copies || 0);
    }, 0);
  }

  // =========================
  // PRINT FUNCTION
  // =========================
  printPageA4(): void {

    const printContent = document.getElementById('print-section');
    if (!printContent) return;

    const printWindow = window.open('', '_blank', 'width=1000,height=800');
    if (!printWindow) return;

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Print</title>

        <style>

          * {
            box-sizing: border-box;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          @page {
            size: A4 portrait;
            margin: 10mm;
          }

          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            font-size: 12px;
            color: #000;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th,
          td {
            border: 1px solid #000;
            padding: 5px;
          }

          th {
            font-weight: bold;
            text-align: center;
          }

          .text-left { text-align: left; }
          .text-center { text-align: center; }
          .text-right { text-align: right; }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          @media print {
            html, body {
              width: 210mm;
              height: 297mm;
            }
            .noPrint {
              display: none !important;
            }
          }

        </style>

      </head>

      <body>
        ${printContent.innerHTML}
      </body>

      </html>
    `);

    printWindow.document.close();

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 500);
  }

  // =========================
  // EXPORT EXCEL WITH TOTAL
  // =========================
  exportExcel(fileName: string) {

    // 1. Prepare data for Excel — use this.sellerData (the actual rows),
    //    not this.data (the raw dialog-injection wrapper),
    //    and use the real field names returned by the API.
    const exportData = this.sellerData.map((row) => ({
      'Seller Name': row.subscribers_name || '',
      'Taluka': row.taluka || '',
      'District': row.district || '',
      'Book Copies': row.book_copies || 0,
      'Representative': row.rep_name || '',
      'Dist Mode': row.DeliveryMode || ''
    }));

    // 2. Add TOTAL row
    exportData.push({
      'Seller Name': 'TOTAL',
      'Taluka': '',
      'District': '',
      'Book Copies': this.totalCopies,
      'Representative': '',
      'Dist Mode': ''
    });

    // 3. Create worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

    // 4. Create workbook
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Report': worksheet },
      SheetNames: ['Report']
    };

    // 5. Convert to buffer
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    // 6. Save file
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/octet-stream'
    });

    saveAs(data, `${fileName}.xlsx`);
  }
}